<!-- begin::Brand -->
<div class="aside-logo justify-content-center" id="qrpay_aside_logo">
  <!-- begin::Logo -->
  <ng-container *ngIf="asideTheme === 'dark'">
    <a routerLink="/">
      <img
        alt="Logo"
        class="h-45px logo custom-logo"
        [src]="whiteLabel.customLogo"
      />
    </a>
  </ng-container>

  <ng-container *ngIf="asideTheme === 'light'">
    <a routerLink="/">
      <img
        alt="Logo"
        class="h-45px logo custom-logo"
        [src]="whiteLabel.customLogo"
      />
    </a>
  </ng-container>

  <!-- end::Logo -->

</div>
<!-- end::Brand  -->

<!-- begin::Aside menu -->
<div class="aside-menu flex-column-fluid">
  <div
    #ktAsideScroll
    id="qrpay_aside_menu_wrapper"
    class="hover-scroll-overlay-y my-5 my-lg-0"
    data-kt-scroll="true"
    data-kt-scroll-activate="{default: false, lg: true}"
    data-kt-scroll-height="auto"
    data-kt-scroll-dependencies="#qrpay_aside_logo, #qrpay_aside_footer"
    data-kt-scroll-wrappers="#qrpay_aside_menu"
    data-kt-scroll-offset="0"
  >
    <div
      id="#qrpay_aside_menu"
      data-kt-menu="true"
      class="
        menu
        menu-column
        menu-title-gray-800
        menu-state-title-primary
        menu-state-icon-primary
        menu-state-bullet-primary
        menu-arrow-gray-500
      "
    >
      <app-aside-menu id="asideMenu"></app-aside-menu>
    </div>
  </div>
</div>
<!-- end::Aside menu -->

<!-- begin::Footer -->
<div class="aside-footer flex-column-auto pt-5 pb-7 px-5" id="qrpay_aside_footer">
  <div class="menu-content d-flex align-items-center px-3">

    <div
      class="d-flex align-items-center"
      id="qrpay_header_user_menu_toggle"
    >
      <!-- begin::Toggle -->

      <div
        class="cursor-pointer symbol d-flex align-items-center"

        data-kt-menu-trigger="click"
        data-kt-menu-attach="parent"
        data-kt-menu-placement="bottom-start"
        data-kt-menu-flip="bottom"
      >
        <img *ngIf="!user.currentUserValue.picture" src="/assets/media/icons/custom/user.svg" alt="Avatar" />
        <img *ngIf="user.currentUserValue.picture" [src]="user.currentUserValue.picture" alt="Avatar" />
        <p class="mx-3 fw-bold mb-0 text-theme-primary" *ngIf="user.currentUserValue.given_name">{{user.currentUserValue.given_name}} {{user.currentUserValue.family_name}}</p>
        <i class="fi fi-br-angle-down text-white"></i>
      </div>
      <!-- end::Toggle  -->
      <app-user-inner></app-user-inner>
    </div>
    <!-- end::User -->

  </div>
</div>
<!-- end::Footer -->
